export default {
  pl: 'PL',
  en: 'EN',
};
